import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { env, routes } from '@/shared/lib';

const AuthErrorPage = lazy(() => import('./auth-error-page'));
const MeetingGroupById = lazy(() => import('./meeting-group-by-id'));
const ActiveConversationsPage = lazy(() => import('./active-conversations-page'));
// const ServersPage = lazy(() => import('./workspace-page'));
// const ServersSessionsPage = lazy(() => import('./workspace-conversation-page'));
const ConversationPage = lazy(() => import('./conversation-page'));
// const DiscordVoicePage = lazy(() => import('./discord-voice-page'));
const MeetingGroupsPage = lazy(() => import('./meeting-groups-page'));
const ProfilePage = lazy(() => import('./profile-page'));
const SupportCenterPage = lazy(() => import('./support-center-page'));
const TariffsPage = lazy(() => import('./tariffs-page'));
const CompanyManagementPage = lazy(() => import('./company-management-page'));
const TemplatesPage = lazy(() => import('./templates-page'));
const TemplateDetailPage = lazy(() => import('./template-detail-page'));
const TemplateProtocolPage = lazy(() => import('./template-protocol-page'));

const SupportCenterRoute = () =>
  env.VITE_SHOW_SUPPORT_CENTER === 'true' ? (
    <SupportCenterPage />
  ) : (
    <Navigate to={routes.MAIN} replace />
  );

export const publicRoutes = [
  {
    path: routes.AUTH_ERROR,
    Component: <AuthErrorPage />,
  },
];

export const privateRoutes = [
  {
    path: routes.MAIN,
    Component: <MeetingGroupsPage />,
  },
  {
    path: routes.PROFILE,
    Component: <ProfilePage />,
  },
  {
    path: routes.TARIFFS,
    Component: <TariffsPage />,
  },
  {
    path: routes.SUPPORT,
    Component: <SupportCenterRoute />,
  },
  {
    path: `${routes.COMPANY_MANAGEMENT}/:companyId`,
    Component: <CompanyManagementPage />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById`,
    Component: <MeetingGroupById />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById${routes.SERVERS}/:guildId${routes.SESSIONS}/:sessionId`,
    Component: <ConversationPage />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById${routes.SERVERS}/:guildId${routes.SESSIONS}/:sessionId/live`,
    Component: <ConversationPage isLive />,
  },
  {
    path: routes.ACTIVE_CONVERSATIONS,
    Component: <ActiveConversationsPage />,
  },
  {
    path: routes.TEMPLATES,
    Component: <TemplatesPage />,
  },
  {
    path: `${routes.TEMPLATES}/:templateId`,
    Component: <TemplateDetailPage />,
  },
  {
    path: `${routes.TEMPLATE_PROTOCOL}/:sessionId`,
    Component: <TemplateProtocolPage />,
  },
];
